/**
 * Reasons for halting Closed Loop Rescission (CLR)
 * These are required when an underwriter checks the "Halt CLR" checkbox
 */
export const CLR_HALT_REASONS = [
  'On notice at time of application',
  'Guidelines not followed',
  'Evidence of diagnosis or treatment is after application date',
  'No evidence the applicant was aware of results or suspected diagnosis',
  'Application did not contemplate reason for recommended rescission',
  'Records not recent',
  'CLR not required as CLR Trigger criteria not met',
] as const;

export type ClrHaltReason = (typeof CLR_HALT_REASONS)[number];

export const CLR_HALT_REASONS_OPTIONS = CLR_HALT_REASONS.map(reason => ({
  value: reason,
  label: reason,
}));
